import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/integration/mutationTypes';

export default {
  [types.SET_INTEGRATION_BY_CATEGORY]: createSetPropMutation('integrationsByCategory', []),
  [types.CLEAR_INTEGRATION_BY_CATEGORY]: createSetPropMutation('integrationsByCategory', []),
  [types.CLEAR_INTEGRATION_TESTING_LOADING]: createClearPropMutation('integrationTestingLoading', false),
  [types.SET_INTEGRATION_TESTING_LOADING]: createSetPropMutation('integrationTestingLoading', false),
  [types.CLEAR_INTEGRATION_DETAILS_FOR_EDIT]: createClearPropMutation('integrationDetailsToEdit', {}),
  [types.SET_INTEGRATION_DETAILS_FOR_EDIT]: createSetPropMutation('integrationDetailsToEdit', {}),
  [types.SET_INTEGRATION_DETAILS]: createSetPropMutation('integrationDetails', {}),
  [types.CLEAR_INTEGRATION_DETAILS]: createClearPropMutation('integrationDetails', {}),
  [types.CLEAR_INTEGRATION_OPTIONS_LIST]: createClearPropMutation('integrationOptionsList', []),
  [types.SET_INTEGRATION_OPTIONS_LIST]: createSetPropMutation('integrationOptionsList', []),
  [types.SET_INTEGRATIONS_LIST_LOADING]: createSetPropMutation('integrationsLoading', false),
  [types.SET_INTEGRATIONS]: createSetPropMutation('integrations', []),
  [types.CLEAR_INTEGRATIONS]: createClearPropMutation('integrations', []),
  [types.CLEAR_INTEGRATIONS_LIST_OPTIONS]: createClearPropMutation('integrationListOptions'),
  [types.SET_INTEGRATIONS_LIST_OPTIONS](state, options = {}) {
    state.integrationListOptions = {
      ...(state.integrationListOptions || {}),
      ...options,
    };
  },
};
